import React from "react";
import { useDispatch } from "react-redux";
import {
  enqueueSuccessSnackbar,
  enqueueErrorSnackbar
} from "../redux/actions/snackbarActions";

export function useSnackbarNotifications() {
  const dispatch = useDispatch();

  const displaySuccessMessage = React.useCallback(message => {
    dispatch(enqueueSuccessSnackbar({ message }));
  }, []);
  const displayErrorMessage = React.useCallback(message => {
    dispatch(enqueueErrorSnackbar({ message }));
  }, []);

  return {
    displaySuccessMessage,
    displayErrorMessage
  };
}
